import { Injectable } from '@angular/core';  
import {  
  HttpInterceptor,  
  HttpRequest,  
  HttpHandler,  
  HttpEvent,  
  HttpResponse  
} from '@angular/common/http';  
import { Observable } from 'rxjs';  
import { tap } from 'rxjs/operators';  
import { BackendService } from './backend.service';  
  
@Injectable()  
export class DCLocationInterceptor implements HttpInterceptor {  
  
  constructor(private backendService: BackendService) {}  
  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {  
    if (this.backendService.DCLocation) {  
      request = request.clone({  
        setHeaders: { DCLocation: this.backendService.DCLocation }  
      });  
    }  
  
    return next.handle(request).pipe(  
      tap((event: HttpEvent<any>) => {  
        if (event instanceof HttpResponse) {  
          if (event.headers.has('DCLocation') && !/\/content\//.test(event.url)) {  
            const dcLocation = event.headers.get('DCLocation');  
            this.backendService.DCLocation = dcLocation;  
  
            // Set sessionStorage ONLY on the tyRewardsSignon page  
            const urlParams = new URLSearchParams(window.location.search);  
            if (urlParams.get('pageName') === 'tyRewardsSignon') {  
              sessionStorage.setItem('dcLocation', dcLocation);  
            }  
          }  
        }  
      })  
    );  
  }  
}